export const SPEAKER_ID_PREFIX = 'SPEAKER_';
